import { render, staticRenderFns } from "./ManterSeriesView.vue?vue&type=template&id=d31a9246"
import script from "./ManterSeriesView.vue?vue&type=script&lang=js"
export * from "./ManterSeriesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports